import Date from "../Date";
import unary from "./unary";

const dateFromUnix = unary(Date.unix);

export default dateFromUnix;
